"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _CacheWaitItem = _interopRequireDefault(require("./CacheWaitItem"));

var _CacheNotFoundItem = _interopRequireDefault(require("./CacheNotFoundItem"));

var _ServiceFacadeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/ServiceFacadeException"));

var _TypeException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/TypeException"));

var _AbstractMethodException = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/exception/AbstractMethodException"));

var _CacheStore = _interopRequireDefault(require("@ikea-aoa/ikea-shared-utils/lib/CacheStore"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var DEFAULT_CACHE_EXPIRE = 60000;
/**
 * This class is used for providing general functionality for a facade.
 *
 * @abstract
 */

var AbstractServiceFacade = /*#__PURE__*/function () {
  function AbstractServiceFacade() {
    _classCallCheck(this, AbstractServiceFacade);
  }

  _createClass(AbstractServiceFacade, null, [{
    key: "clearCache",

    /**
     * Clears the cache.
     *
     * @param {Error} [error] Error object causing the cache clear.
     */
    value: function clearCache() {
      var error = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
      var rejects = [];

      var _iterator = _createForOfIteratorHelper(this.cacheStore.values()),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item = _step.value;

          if (item.value && item.value.isWaiting) {
            rejects.push(item.value.reject.bind(item.value));
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      this.cacheStore.clear();

      for (var _i = 0, _rejects = rejects; _i < _rejects.length; _i++) {
        var reject = _rejects[_i];
        var causedBy = error ? ' Caused by: ' + error.message + '\n' + error.stack : '';
        reject(new _ServiceFacadeException.default('Failed to resolve item as the cache got cleared.' + causedBy, this.constructor.serviceName));
      }
    }
    /**
     * Stores data in cache.
     *
     * @param {object} key Unique object as identifier.
     * @param {object} value Value to store.
     */

  }, {
    key: "setCacheItem",
    value: function setCacheItem(key, value) {
      if (this.cacheExpireTime === 0) {
        return;
      }

      var cacheKey = this._createCacheKey(key);

      var cacheItem = this.cacheStore.get(cacheKey);
      this.cacheStore.set(cacheKey, {
        value: value,
        expire: this.cacheExpireTime === -1 ? null : Date.now() + this.cacheExpireTime
      });

      if (cacheItem && cacheItem.value.isWaiting) {
        cacheItem.value.resolve(_typeof(value) === 'object' && value.isNotFound ? null : value);
      }
    }
    /**
     * Sets a cache key as not found.
     *
     * @param {object} key Unique object as identifier.
     */

  }, {
    key: "setCacheItemAsNotFound",
    value: function setCacheItemAsNotFound(key) {
      this.setCacheItem(key, new _CacheNotFoundItem.default(key));
    }
    /**
     * Sets a cache key as waiting.
     *
     * @param {object} key Unique object as identifier.
     */

  }, {
    key: "setCacheItemAsWaiting",
    value: function setCacheItemAsWaiting(key) {
      this.setCacheItem(key, new _CacheWaitItem.default(key, this.maximumAllowedResolveTime));
    }
    /**
     * Retrieves data from cache.
     * If an Array is sent as key, each single item inside it will be loaded separately from the cache store.
     *
     * @param {object} key Unique object as identifier.
     * @returns {object|null} Cached item.
     */

  }, {
    key: "getCacheItem",
    value: function getCacheItem(key) {
      var cacheKey = this._createCacheKey(key);

      var cacheItem = this.cacheStore.get(cacheKey);

      if (cacheItem !== undefined) {
        if (cacheItem.expire !== null && Date.now() > cacheItem.expire) {
          this.cacheStore.delete(cacheKey);
          return null;
        }

        return cacheItem.value;
      }

      return null;
    }
    /**
     * Removes cache item.
     *
     * @param {object} key Unique object as identifier.
     */

  }, {
    key: "removeCacheItem",
    value: function removeCacheItem(key) {
      this.cacheStore.delete(this._createCacheKey(key));
    }
    /**
     * Creates a cache key.
     *
     * @param {object} key Unique object as identifier.
     * @returns {string} Cache key.
     */

  }, {
    key: "_createCacheKey",
    value: function _createCacheKey(key) {
      if (!key) {
        throw new _TypeException.default('Failed to create cache key. Value was "undefined" or "null".');
      }

      if (_typeof(key) === 'object') {
        if (this.cacheKeyProperties) {
          var sortedKey = {};

          var _iterator2 = _createForOfIteratorHelper(this.cacheKeyProperties),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var property = _step2.value;
              sortedKey[property] = typeof key[property] === 'string' ? key[property].toLowerCase() : key[property];
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          return JSON.stringify(sortedKey);
        } else {
          var _sortedKey = [];
          var keyProperties = Object.keys(key);
          keyProperties.sort();

          for (var _i2 = 0, _keyProperties = keyProperties; _i2 < _keyProperties.length; _i2++) {
            var name = _keyProperties[_i2];
            var value = typeof key[name] === 'string' ? key[name].toLowerCase() : key[name];

            _sortedKey.push({
              name: name,
              value: value
            });
          }

          return JSON.stringify(_sortedKey);
        }
      }

      return key.toString();
    }
    /**
     * Retrieves data from cache and returns it as a promise.
     *
     * @param {object} key Unique object as identifier.
     * @param {boolean} [addCacheWaitItem] TRUE to add a cache wait item for other requests calling the same method. Default is TRUE.
     * @returns {Promise|null} Promise object or null if there is no ongoing request.
     */

  }, {
    key: "_getCachePromise",
    value: function _getCachePromise(key) {
      var addCacheWaitItem = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (key === undefined || key === null) {
        throw new _TypeException.default('Property with name "key" is null or undefined. Are you calling the service facade correctly?');
      }

      var cachedData = this.getCacheItem(key);

      if (cachedData !== null) {
        return new Promise(function (resolve, reject) {
          if (cachedData.isWaiting) {
            cachedData.resolves.push(resolve);
            cachedData.rejects.push(reject);
          } else {
            resolve(_typeof(cachedData) === 'object' && cachedData.isNotFound ? null : cachedData);
          }
        });
      } else if (addCacheWaitItem && !cachedData) {
        this.setCacheItemAsWaiting(key);
      }

      return null;
    }
    /**
     * Clears cache and calls a reject callback.
     *
     * @param {Function} reject Reject callback.
     * @param {Error} error Error object.
     */

  }, {
    key: "_clearCacheAndReject",
    value: function _clearCacheAndReject(reject, error) {
      this.clearCache(error);
      reject(error);
    }
    /**
     * Returns the cache store.
     *
     * @returns {CacheStore} Cache store.
     */

  }, {
    key: "cacheStore",
    get: function get() {
      this._cacheStore = this._cacheStore || new _CacheStore.default(this.serviceName);
      return this._cacheStore;
    }
    /**
     * Returns the service name.
     *
     * @abstract
     * @returns {string} Service name.
     */

  }, {
    key: "serviceName",
    get: function get() {
      throw new _AbstractMethodException.default();
    }
    /**
     * Returns the maximum allowed resolve time.
     *
     * @returns {number} Maximum allowed resolve time. Default is 20000.
     */

  }, {
    key: "maximumAllowedResolveTime",
    get: function get() {
      return 20000;
    }
    /**
     * Sets cache expire time in ms.
     *
     * @param {number} cacheExpireTime Cache expire time in ms.
     */

  }, {
    key: "cacheExpireTime",
    set: function set(cacheExpireTime) {
      this._cacheExpireTime = cacheExpireTime;
    }
    /**
     * Returns cache expire time in ms.
     *  - "0" will disable caching.
     *  - "-1" will cache it the entire session.
     *
     * @returns {number} Cache expire time in ms.
     */
    ,
    get: function get() {
      return typeof this._cacheExpireTime === 'number' ? this._cacheExpireTime : DEFAULT_CACHE_EXPIRE;
    }
    /**
     * Returns properties to use if cache key is object.
     *
     * @returns {string[]} Properties to use if cache key is an object. Default is to use the entire object.
     */

  }, {
    key: "cacheKeyProperties",
    get: function get() {
      return null;
    }
  }]);

  return AbstractServiceFacade;
}();

exports.default = AbstractServiceFacade;